import { Geolocation, Geoposition } from '@ionic-native/geolocation';
import { IonButton, IonLoading, IonToast } from '@ionic/react';
import React, { useState } from 'react';

interface LocationError {
    showError: boolean;
    message?: string;
}

const GeolocationButton: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<LocationError>({ showError: false });
    const [position, setPosition] = useState<Geoposition>();
    const [startPosition, setStartPos] = useState<Geoposition>();
    const [deltaLatitude, setDeltaLatitude] = useState<number>(0);
    const [deltaLongitude, setDeltaLongitude] = useState<number>(0);

    function startSampling()
    {
        setInterval(getLocation, 1000);
        
    }

    const getLocation = async () => {

        setLoading(true);

        try {
            const position = await Geolocation.getCurrentPosition();
            setPosition(position);
            setLoading(false);
            setError({ showError: false });
            if (position)
            {
                if (!startPosition)
                {
                    setStartPos(position);
                }

                if (startPosition)
                {
                    const dLat : number = position.coords.latitude - startPosition.coords.latitude;
                    const dLong: number = position.coords.longitude - startPosition.coords.longitude;
                    setDeltaLatitude(dLat);
                    setDeltaLongitude(dLong);
                }
            }
        } catch (e) {
            console.log(e);
            setError({ showError: true, message: "Some location error?" });
            setLoading(false);
        }
    }

    return (
        <>
            <IonLoading
                isOpen={loading}
                onDidDismiss={() => setLoading(false)}
                message={'Getting Location...'}
            />
            <IonToast
                isOpen={error.showError}
                onDidDismiss={() => setError({ message: "", showError: false })}
                message={error.message}
                duration={3000}
            />
            <IonButton color="primary" onClick={startSampling}>{position ? `${deltaLatitude * 1000} ${deltaLongitude * 1000}` : "Get Location"}</IonButton>
        </>
    );
};

export default GeolocationButton;